import React from 'react';
import { shareIcons, icons, playIcon } from '../../shared/styles/icons';
import { styles } from './styles/VideoModalThumbStyles';
import { StyleSheet, css } from 'aphrodite/no-important';

class VideoModalThumbnail extends React.Component {
    constructor(props) {
        super(props);    

        this.state = {
            activeIndex: this.props.activeIndex,
        }

        this.post = this.props.post || {};
        this.toggleVideoHover = this.toggleVideoHover.bind(this);
        this.updateCurrentPost = (e) => this.props.onClick(this.post);
        
    }

    toggleVideoHover(){
		this.setState({videoHover: !this.state.videoHover});
	}


    componentDidMount(){ 

    }

    componentDidUpdate(){

    }

    render(){
        let post = this.post;
        let titleStyles = [styles.thumbTitle];
        let nowPlayingStyles = [icons.icNowPlaying];
        let thumbOverlayStyles = [styles.thumbOverlay];

        let playBtnStyles = [playIcon.icPlayTiny, styles.zIndexOne];

        if (this.state.videoHover) {
			playBtnStyles.push(playIcon.icPlayTinyHover);
		}

        return (
            <a href="#" className={css(styles.videoTplCont) + ' more-thumb-link'} onClick={this.updateCurrentPost} data-release-url={post.releaseUrl}
            onMouseEnter={this.toggleVideoHover} onMouseLeave={this.toggleVideoHover}>
                <div className={css(thumbOverlayStyles)}></div>
                <div className={css(styles.videoThumb)}>
                    <div className={css(styles.imgOverlay)}>
                        <img src={post.thumb} className={css(styles.imgThumb)}/>
                        <span className={css(styles.playCont)}>
                            <span className={css(styles.playIcon) + ' play-icon_vc'}>
                                <span className={css(playBtnStyles) + ' play-dtn_vc'}></span>
                                {post.duration &&
                                    <span className={css(styles.durationContainer)}>
                                        <span className={css(styles.duration)}>{post.duration}</span>
                                    </span>
                                }
                            </span>
                        </span>
                    </div>
                </div>
                <div className={css(styles.meta)}>
                    {/* { this.props.isActive && <span className={css(styles.upNext)}> UP NEXT </span> } disabling for now*/}
                    <span className={css(titleStyles)}> {post.title} </span>
                </div>
            </a>    
        )
    }

}

export default VideoModalThumbnail;



// WEBPACK FOOTER //
// ./react-app-src/videoModal/components/VideoModalThumbnail.js